export enum PptFormatEnum {
  FULL_DETAIL = "Full Detail",
  FULL_DETAIL_COMPRESS = "Full Detail(Compress)",
  LESS_DETAIL = "Less Detail",
  LESS_DETAIL_COMPRESS = "Less Detail(Compress)",
  CUSTOMER_SPECIFIC = "Customer Configured",
  VENDOR_SPECIFIC = "Vendor Specific",
  LAYOUT_V1_FULL_DETAIL = "Full Detail(Layout1)",
  LAYOUT_V1_LESS_DETAIL = "Less Detail(Layout1)"
}
